<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/task/Task' }">用户课程列表</el-breadcrumb-item>
            <el-breadcrumb-item>视频列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 返回 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-back" @click="toScreen()">返回</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openVideo()">添加</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="VideoData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" sortable prop="tagName" label="标签名称" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="title" label="课程标题" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="url" label="视频" width="120">
                <template slot-scope="scope">
                    <video :src="scope.row.url" style="width: 60px;min-height:80px;" v-if="scope.row.url" controls>
                        Your browser does not support the video tag.
                    </video>
                    <div v-if="scope.row.url == null">没有视频</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="episodes" label="集数" width="120"></el-table-column>
            <el-table-column align="center" sortable prop="amount" label="钻石数" width="120"></el-table-column>
            <!-- <el-table-column align="center" sortable prop="videoImage" label="视频封面图" width="120">
                <template slot-scope="scope">
                    <img v-if="scope.row.videoImage" style="width: 90px;height: 90px;" :src="scope.row.videoImage">
                    <div v-if="scope.row.videoImage == null">没有图片</div>
                </template>
            </el-table-column> -->
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="400">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="getVideoxq(scope.row)">查看视频详情</el-button>
                    <el-button size="mini" type="primary" @click="openVideo(scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" @click="deleVideo(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
            <el-form label-width="120px">
                <el-form-item label="播放路径" prop="url">
                    <div style="display: flex; align-items: center;">
                        <el-upload action="" :http-request="mainVideoUpload" :show-file-list="false"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <video :src="url" style="width: 60px;min-height:80px;margin-left: 14px;" v-if="url" controls>
                           
                        </video>
                        <div v-else style="margin-left: 14px;">目前没有视频</div>
                    </div>
                </el-form-item>
                <el-form-item label="集数" prop="episodes">
                    <el-input size="small" v-model="episodes" auto-complete="off" placeholder="请输入视频集数"></el-input>
                </el-form-item>
                <el-form-item label="钻石数" prop="amount">
                    <el-input size="small" v-model="amount" auto-complete="off" placeholder="请输入钻石数"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input size="small" v-model="sort" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="标签名称">
                    <el-select v-model="tagId" placeholder="请选择标签名称">
                        <el-option v-for="item in optionsTag" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="视频封面图">
                    <div style="display: flex; align-items: center;">
                        <el-upload action="" :http-request="mainImgUpload" :show-file-list="false"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-image v-if="videoImage" :src="videoImage"
                            style="width: 140px;height: 140px;margin-left: 14px;" :preview-src-list="[videoImage]" />
                        <div v-else style="margin-left: 14px;">目前没有图片</div>
                    </div>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="btnLoading" @click="addVideo()"
                    v-if="tit == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="btnLoading" @click="upVideo()"
                    v-if="tit == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 视频详情 -->
        <el-dialog title="视频详情页：" :visible.sync="editFormDetails" width="50%">
            <el-form label-width="120px">
                <el-form-item label="标签名称：" prop="title">
                    <span v-html="this.Details.tagName"></span>
                </el-form-item>
                <el-form-item label="课程标题：" prop="title">
                    <span v-html="this.Details.title"></span>
                </el-form-item>
                <el-form-item label="集数：" prop="episodes">
                    <span v-html="this.Details.episodes"></span>
                </el-form-item>
                <el-form-item label="钻石数：" prop="amount">
                    <span v-html="this.Details.amount"></span>
                </el-form-item>
                <el-form-item label="视频：" prop="url"> 
                    <video :src="this.Details.url" style="width: 80px;margin-left: 14px;min-height:80px;" v-if="this.Details.url"
                        controls></video>
                </el-form-item>
                <!-- <el-form-item label="视频封面图：" prop="videoImage">
                    <el-image v-if="this.Details.videoImage" :src="this.Details.videoImage"
                        style="width: 140px;height: 140px;margin-left: 14px;"
                        :prdeview-src-list="[this.Details.videoImage]" />
                    <div v-else>没有图片</div>
                </el-form-item> -->
                <el-form-item label="创建时间：" prop="createTime">
                    {{ transformDate(this.Details.createTime) }}
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import {
    getTaskTagList,
    getAdminTaskRoomList,
    getAdminTaskRoomInfo,
    addAdminTaskRoom,
    deleteAdminTaskRoom,
    upAdminTaskRoom
} from '../../api/userMG'
export default {
    data() {
        return {
            editFormVisiible: false,
            url: '',
            episodes: '',
            taskId: this.$route.query.id,
            videoImage: '',
            amount: '',
            sort: '',
            loading: false,
            btnLoading:false,
            tit: '添加',
            VideoData: [],
            editFormDetails: false,
            Details: [],
            optionsTag: [],
            tagId: ''
        }
    },
    created() {
        this.getVideo(1)
        this.shuju()
    },
    methods: {
        shuju() {
            getTaskTagList().then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    res.data.list.forEach((item) => {
                        this.optionsTag.push({ label: item.name, value: item.id })
                    })
                    return;
                }
            })
        },
        // 返回上一页
        toScreen() {
            this.$router.go(-1)
        },
        // 查看视频详情
        getVideoxq(row) {
            this.loading = true;
            this.editFormDetails = true;
            let data = {
                id: row.id
            }
            getAdminTaskRoomInfo(data).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.Details = res.data.data;
                    return;
                }
            })
        },
        // 删除
        deleVideo(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deleteAdminTaskRoom(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getVideo(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 修改
        upVideo() {
            this.loading = true
            upAdminTaskRoom({
                id: this.id,
                url: this.url,
                episodes: this.episodes,
                amount: this.amount,
                taskId: this.taskId,
                sort: this.sort,
                // videoImage: this.videoImage,
                tagId: this.tagId,
                tagValue: 100
            }).then((res) => {
                if (res.code == 200) {
                    this.loading = false
                    this.$message.success(res.msg)
                    this.editFormVisiible = false
                    this.getVideo(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 添加
        addVideo() {
            this.loading = true
            addAdminTaskRoom({
                url: this.url,
                episodes: this.episodes,
                amount: this.amount,
                taskId: this.taskId,
                sort: this.sort,
                // videoImage: this.videoImage,
                tagId: this.tagId,
                tagValue: 100
            }).then((res) => {
                if (res.code == 200) {
                    this.loading = false
                    this.$message.success(res.msg)
                    this.editFormVisiible = false
                    this.getVideo(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },
        // 自定义上传方法 视频的
        mainVideoUpload(file) {
            this.btnLoading=true
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            const names = ["video", "mp4"];
            if (names.indexOf(exname) < 0) {
                this.$message.error("不支持的格式!");
                return;
            }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
            this.btnLoading=false
                    console.log('res===upload======',res)
                    if (res.url) {
                        this.url = res.url
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },
        // 自定义上传方法 图片的
        mainImgUpload(file) {
            // 判断扩展名
            const tmpcnt = file.file.name.lastIndexOf(".");
            const exname = file.file.name.substring(tmpcnt + 1);
            const names = ["jpg", "jpeg", "webp", "png", "bmp"];
            if (names.indexOf(exname) < 0) {
                this.$message.error("不支持的格式!");
                return;
            }
            const fileName = file.file.uid + "." + exname;
            client
                .put(fileName, file.file)
                .then((res) => {
                    if (res.url) {
                        this.videoImage = res.url
                    } else {
                        this.$message.error("文件上传失败");
                    }
                })
                .catch((err) => { });
        },
        //打开编辑页面
        openVideo(row) {
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.tit = "修改"
                this.id = row.id
                this.url = row.url
                this.episodes = row.episodes
                this.amount = row.amount
                this.taskId = row.taskId
                this.sort = row.sort
                // this.videoImage = row.videoImage
                this.tagId = row.tagId
            } else {
                this.tit = "添加"
                this.url = ""
                this.episodes = ""
                // this.videoImage = ""
                this.amount = ""
                this.sort = ""
                this.tagId = ""
                this.taskId = row.taskId
            }
        },
        // 获取列表数据
        getVideo(page) {
            this.loading = true;
            let data = {
                taskId: this.taskId,
                page: (page - 1) * 20
            }
            getAdminTaskRoomList(data).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    console.log(res.data.list)
                    this.VideoData = res.data.list;
                    return;
                } else {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    })
                }
            })
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/task/TaskToVideo.vue